import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVisit = async (visitId, vin) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/vehicles/${vin}/visits/${visitId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteVisit = async (vin, visitId) => {
  try {
    return await AUTH_API.delete(`/api/v1/vehicles/${vin}/visits/${visitId}`);
  } catch (error) {
    return handleApiError(error);
  }
};

export const completeVisit = async (vin, visitId) => {
  try {
    return await AUTH_API.post(`/api/v1/vehicles/${vin}/visits/${visitId}/finish`);
  } catch (error) {
    return handleApiError(error);
  }
};

export const splitVisit = async (vin, visitId, body) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles/${vin}/visits/${visitId}/split`, body);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateVisit = async (vin, visitId, visit) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/vehicles/${vin}/visits/${visitId}`, visit);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const downloadInvoice = async (vin, visitId) => {
  try {
    return await AUTH_API.get(`/api/v1/vehicles/${vin}/visits/${visitId}/invoice`, {
      responseType: 'blob',
    });
  } catch (error) {
    return handleApiError(error);
  }
};
